export enum InteractiveSplineToolEnum {
  Drawing,
  Dragging,
}
